import { render, staticRenderFns } from "./SecondaryNavItem.vue?vue&type=template&id=04a55e9e&scoped=true&"
import script from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
export * from "./SecondaryNavItem.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryNavItem.vue?vue&type=style&index=0&id=04a55e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a55e9e",
  null
  
)

export default component.exports